import React from "react";
import { LongTextLabel, Toast } from "@sscs/ui";
import { ActionMenu, Dialog } from "Components";
import { PERMISSION } from "Constants";
import { useDialog } from "Hooks";
import { ActionItem, ExportJob } from "Types";
import { apiErrorToast } from "Utils";
import { useDeleteAuditExportMutation } from "../../services/audit.api";

type ExportJobActionProps = {
  exportJob: ExportJob;
  rowIndex: number;
};

const ExportJobActions = ({
  exportJob,
  rowIndex,
}: ExportJobActionProps): React.JSX.Element => {
  const deleteDialog = useDialog();

  const [deleteExportJob] = useDeleteAuditExportMutation();

  const actionItems: ActionItem[] = [
    {
      id: "delete_export_job",
      type: "DELETE",
      text: "Delete export",
      onClick: () => deleteDialog.open(),
      permissions: [PERMISSION.VIEW_AUDIT],
    },
  ];
  return (
    <>
      <ActionMenu id={`audit-export-actions-${rowIndex}`} items={actionItems} />
      <Dialog
        title="Delete export?"
        confirmText="Delete"
        cancelText="No"
        onConfirm={async () => {
          try {
            await deleteExportJob(exportJob.id).unwrap();

            Toast.show({
              title: `Export ${exportJob.name} deleted`,
              type: "success",
            });
          } catch (error) {
            apiErrorToast(error, "Could not delete export");
            deleteDialog.close();
            return;
          }
        }}
        onCancel={deleteDialog.close}
        isOpen={deleteDialog.isOpen}
        onClose={deleteDialog.close}
        cancelButtonColor="primary"
        confirmButtonColor="secondary"
      >
        Are you sure you want to delete export{" "}
        <LongTextLabel label={exportJob.name} inline={true} />?
      </Dialog>
    </>
  );
};

export default ExportJobActions;
